import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

import {allLayers} from 'src/app/constants/layer';
import {MapboxGlService} from 'src/app/services/mapbox-gl.service';


@Component({
    selector: 'app-mapboxgl-layer',
    templateUrl: './mapboxgl-layer.component.html',
    styleUrls: ['./mapboxgl-layer.component.scss']
})
export class MapboxglLayerComponent implements OnInit {

    public layers: any[] = [];
    public service: MapboxGlService;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        public dialogRef: MatDialogRef<MapboxglLayerComponent>
    ) {
        this.service = this.data.service;
    }

    ngOnInit(): void {
        this.layers = allLayers.filter(layer => layer.id)
            .sort((a, b) => a.name.localeCompare(b.name));
    }

    toggleLayer(layer: any): void {
        this.service.toggleShowLayer(layer.id);
    }

    close(): void {
        this.dialogRef.close();
    }

}
